import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'

export default function Banner() {
  return (
    <div>
         <section className='portfolio_banner'>
            <Container>
                <Row>
                    <Col lg={12} md={12}>
                        <div className="head">
                            <h2>Portfolio</h2>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    </div>
  )
}
